"use client";
import Hero2 from "@/components/common/hero2";
import { useModalContext } from "@/contexts/ModalContext";

interface Hero2ClientProps {
    title: string;
    description: string;
    subtext?: string;
    quote?: string;
    author?: string;
    btn?: string;
    btn1?: string;
    href?: string;
    target?: "_blank" | "_self";
}

const Hero2Client = ({ 
    title, 
    description, 
    subtext, 
    quote, 
    author, 
    btn, 
    btn1, 
    href, 
    target 
}: Hero2ClientProps) => {
    const modal = useModalContext();

    const handleModalOpen = (modalTitle?: string) => {
        modal.openModal(modalTitle);
    };

    return (
        <Hero2
            title={title}
            description={description}
            subtext={subtext}
            quote={quote}
            author={author}
            btn={btn}
            btn1={btn1}
            href={href}
            target={target}
            onModalOpen={handleModalOpen}
        />
    );
};

export default Hero2Client;
